
import request from '../../utils/request';
/**
 * 分页查询定时任务列表
 */
export const getJobList = (params) => {
    return request.get('/api/job/list', { params });
};

/**
 * 获取任务详情
 */
export const getJobDetail = (jobId) => {
    return request.get(`/api/job/${jobId}`);
};

/**
 * 添加任务
 */
export const addJob = (data) => {
    return request.post('/api/job', data);
};

/**
 * 修改任务
 */
export const updateJob = (data) => {
    return request.put('/api/job', data);
};

/**
 * 删除任务
 */
export const deleteJob = (jobId) => {
    return request.delete(`/api/job/${jobId}`);
};

/**
 * 暂停任务
 */
export const pauseJob = (jobId) => {
    return request.post(`/api/job/${jobId}/pause`);
};

/**
 * 恢复任务
 */
export const resumeJob = (jobId) => {
    return request.post(`/api/job/${jobId}/resume`);
};

/**
 * 立即执行一次
 */
export const runJob = (jobId) => {
    return request.post(`/api/job/${jobId}/run`);
};

/**
 * 分页查询任务执行日志
 */
export const getJobLogList = (params) => {
    return request.get('/api/job/log/list', { params });
};

/**
 * 手动触发任务（带参数）
 */
export const triggerJob = (param) => {
    const { jobId, ...restParams } = param;
    return request.post(`/api/job/${jobId}/trigger`, restParams);
};

/**
 * 删除任务日志
 */
export const deleteJobLog = (logId) => {
    return request.delete(`/api/job/log/${logId}`);
};

/**
 * 清空任务日志
 */
export const clearJobLog = (jobName) => {
    return request.delete(`/api/job/log/clear`, {
        params: { jobName }
    });
};

